export const documentStorage = {
  title: 'Document Library',
  subtitle: 'Manage documents and folders',
  
  actions: {
    upload: 'Upload',
    newFolder: 'New Folder',
    download: 'Download',
    delete: 'Delete',
    rename: 'Rename',
    move: 'Move',
    search: 'Search...',
    back: 'Back',
    close: 'Close',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    preview: 'Preview',
    filter: 'Filter',
    allCategories: 'All categories',
    allTags: 'All tags',
    addTag: 'Add tag...',
    newCategory: 'New category',
    edit: 'Edit',
    sortBy: 'Sort by',
    sortName: 'By name',
    sortDate: 'By date',
    sortSize: 'By size',
    allTypes: 'All types',
    typePdf: 'PDF',
    typeImage: 'Image',
    typeDoc: 'Document',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    bulkDelete: 'Delete selected',
    bulkDeleteConfirm: 'Are you sure you want to delete {{count}} selected documents?',
    storageUsage: 'Storage usage',
  },
  
  folders: {
    root: 'Root',
    allDocuments: 'All Documents',
    empty: 'No folders',
    name: 'Folder name',
    namePlaceholder: 'New folder name...',
    parent: 'Parent folder',
    create: 'Create Folder',
    deleteConfirm: 'Are you sure you want to delete this folder?',
    deleteWarning: 'Documents in this folder will not be deleted, they will move to root.',
    documentCount: '{{count}} documents',
  },
  
  documents: {
    empty: 'No documents',
    emptyHint: 'Upload or create a new document',
    title: 'Title',
    category: 'Category',
    customer: 'Customer',
    size: 'Size',
    created: 'Created',
    noFile: 'No file attached',
    tags: 'Tags',
    deleteConfirm: 'Are you sure you want to delete this document?',
    deleteWarning: 'This action cannot be undone.',
    editTitle: 'Edit document',
    moveTitle: 'Move document',
    moveFolder: 'Target folder',
    moveFolderHint: 'Select the new folder',
    uploadSuccess: 'Document uploaded successfully',
    uploadError: 'Error during upload',
    deleteSuccess: 'Document deleted',
    deleteError: 'Error during deletion',
  },
  
  upload: {
    title: 'Upload Document',
    dragHere: 'Drag file here or click to select',
    dropHere: 'Drop file here to upload',
    orClick: 'or click to browse',
    selectFile: 'Select File',
    titleField: 'Document title',
    titlePlaceholder: 'Enter a title...',
    categoryField: 'Category',
    customerField: 'Customer',
    selectCustomer: 'Select a customer...',
    general: 'General',
    noCategory: 'No category',
    tags: 'Tags',
    tagsHint: 'Press Enter to add a tag',
  },
  
  messages: {
    folderCreated: 'Folder created',
    folderDeleted: 'Folder deleted',
    folderError: 'Error during folder operation',
    loading: 'Loading...',
    categoryCreated: 'Category created',
    categoryError: 'Error creating category',
  },
  
  categories: {
    title: 'Categories',
    create: 'New Category',
    name: 'Category name',
    namePlaceholder: 'Category name...',
    color: 'Color',
    icon: 'Icon',
  },
  
  preview: {
    title: 'Document Preview',
    noPreview: 'Preview not available',
    noPreviewHint: 'Download the file to view it',
    openInNewTab: 'Open in new tab',
  },
  
  move: {
    title: 'Move',
    targetFolder: 'Target folder',
    root: 'Root (no folder)',
  },
  
  edit: {
    title: 'Edit document',
    titleField: 'Document title',
    categoryField: 'Category',
    tags: 'Tags',
    tagsHint: 'Press Enter to add a tag',
  },
};
